<template>
<v-app>
    <Header @getTypeMenu="changeTypeMenu" :table_name="table_name" :table_type="table_type" :table_detail="table_detail" />
    <TakeOut :typeMenu="typeMenuBuffet" />
    <Advertise :pictureAdvertise="picture_advertise" v-if="open_advertise"/>
    <Footer :table_type="table_type"/>
</v-app>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import Header from '@/components/menuuser/Header.vue'
import TakeOut from '@/components/menuuser/TakeOut.vue'
import Advertise from '@/components/menuuser/Advertise.vue'
import Footer from '@/components/menuuser/Footer.vue'
export default {
    name: 'takeOutUser',
    components: {
        Header,
        TakeOut,
        Advertise,
        Footer,
    },
    data() {
        return {
            typeMenuBuffet: '',
            table_name: '',
            table_type: '',
            table_detail: '',
            open_advertise: false,
            picture_advertise: null,
        }
    },
    methods: {
        async changeTypeMenu(typeMenu) {
            this.typeMenuBuffet = typeMenu
        },
        async checkCartTakeOutNameUser() {
            if (this.$store.state.cartTakeOutNameUser === null) {
                this.$router.push('/nametakeoutuser')
            }
        },
        async tableDetail() {

            this.table_name = ''
            this.table_type = 'takeoutuser'
            this.table_detail = ''

        },
    },
    mounted() {
        this.checkCartTakeOutNameUser()
        this.tableDetail()
        HTTP.get(`/advertiseuser` + `?store_id=${this.$route.query.store_id}&token=`+this.$route.params.token, {
                headers: {
                    "Authorization": `Bearer ${this.$store.state.token}`
                }
            })
            .then((response) => {
                if (response.data.successful === true) {
                    this.picture_advertise = response.data.detail[2].picture
                    const dateTodayList = new Date();
                    const date_month = dateTodayList.getMonth() + 1
                    const date_today = dateTodayList.getFullYear()+'-'+date_month+'-'+dateTodayList.getDate()
                    if (this.$store.state.checkAdvertiseDate != date_today || this.$store.state.checkAdvertiseType != 'takeout') {
                        const data = {
                            date:date_today,
                            type:'takeout'
                        }
                        this.$store.commit('startAdvertise',data)
                    }
                    this.open_advertise = false
                    if (response.data.detail[2].status === 1 && this.$store.state.checkAdvertise) {
                        this.open_advertise = true
                    }
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
    },
}
</script>
